import React from 'react'
import Navbar from '../components/Navbar/Navbar';
import BlogMe from '../components/Blog/BlogMe';
import FooterMe from '../components/Footer/FooterMe';
import 'flowbite'
const Blog = () => {
  return (
    <>
    <Navbar />
    <BlogMe />
    <FooterMe/>
    </>
  )
}

export default Blog
